import { signal } from 'services/SignalsService'
import { timings } from 'settings/custom/freespins'

const name = 'FS-CHOISE-POPUP'

async function execute() {
  const freespinModel = game.models.FreespinModel.get()

  if(timings.hasOwnProperty('transitionChoise') &&  freespinModel.left){
    signal.dispatch('CHOISE-POPUP-ANIM', true)
  }
  else {
    return Promise.resolve()
  }

  return signal.promise('CHOISE-POPUP-ANIM:DONE')
}

export function getFreespinChoicePopupAction() {
  return {
    name,
    execute,
  }
}
